import { render } from "./BurgerFloatButton.vue?vue&type=template&id=5105e39e&scoped=true"
import script from "./BurgerFloatButton.vue?vue&type=script&lang=js"
export * from "./BurgerFloatButton.vue?vue&type=script&lang=js"

import "./BurgerFloatButton.vue?vue&type=style&index=0&id=5105e39e&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5105e39e"]])

export default __exports__